import { render, staticRenderFns } from "./NewUiHeaderCellSortable.vue?vue&type=template&id=26f14aa8&scoped=true&"
import script from "./NewUiHeaderCellSortable.vue?vue&type=script&lang=ts&"
export * from "./NewUiHeaderCellSortable.vue?vue&type=script&lang=ts&"
import style0 from "./NewUiHeaderCellSortable.vue?vue&type=style&index=0&id=26f14aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f14aa8",
  null
  
)

export default component.exports